import { useTheme } from '@mui/material';

/** Farbtöne der Swipe-Seite nach Mockup; im hellen Theme äquivalente Töne. */
export interface SwipePalette {
  page: string;
  card: string;
  cardBorder: string;
  tile: string;
  tileBorder: string;
  tileHover: string;
  text: string;
  muted: string;
  faint: string;
  amber: string;
  amberBg: string;
  amberBorder: string;
  red: string;
  redBg: string;
  redBorder: string;
  green: string;
  greenBg: string;
  greenBorder: string;
  yellow: string;
  yellowBg: string;
  yellowBorder: string;
  blue: string;
  blueBg: string;
  chipBg: string;
  track: string;
  isDark: boolean;
}

const DARK: SwipePalette = {
  page: '#0f1626',
  card: '#141c2e',
  cardBorder: '#233047',
  tile: '#1a2338',
  tileBorder: '#253150',
  tileHover: '#1f2a42',
  text: '#e6ecf5',
  muted: '#8b98ad',
  faint: '#5f6c82',
  amber: '#f0b429',
  amberBg: 'rgba(240, 180, 41, 0.10)',
  amberBorder: 'rgba(240, 180, 41, 0.55)',
  red: '#ef4444',
  redBg: 'rgba(239, 68, 68, 0.12)',
  redBorder: 'rgba(239, 68, 68, 0.65)',
  green: '#22c55e',
  greenBg: 'rgba(34, 197, 94, 0.14)',
  greenBorder: 'rgba(34, 197, 94, 0.65)',
  yellow: '#eab308',
  yellowBg: 'rgba(234, 179, 8, 0.12)',
  yellowBorder: 'rgba(234, 179, 8, 0.65)',
  blue: '#7cb4ff',
  blueBg: 'rgba(96, 165, 250, 0.16)',
  chipBg: 'rgba(255, 255, 255, 0.08)',
  track: 'rgba(255, 255, 255, 0.16)',
  isDark: true,
};

const LIGHT: SwipePalette = {
  page: '#f0f2f5',
  card: '#ffffff',
  cardBorder: '#dfe3e8',
  tile: '#f5f7fa',
  tileBorder: '#e1e6ec',
  tileHover: '#eef1f5',
  text: '#1a2332',
  muted: '#5f7082',
  faint: '#8a97a8',
  amber: '#b7791f',
  amberBg: 'rgba(183, 121, 31, 0.10)',
  amberBorder: 'rgba(183, 121, 31, 0.55)',
  red: '#dc2626',
  redBg: 'rgba(220, 38, 38, 0.08)',
  redBorder: 'rgba(220, 38, 38, 0.55)',
  green: '#16a34a',
  greenBg: 'rgba(22, 163, 74, 0.10)',
  greenBorder: 'rgba(22, 163, 74, 0.55)',
  yellow: '#ca8a04',
  yellowBg: 'rgba(202, 138, 4, 0.10)',
  yellowBorder: 'rgba(202, 138, 4, 0.55)',
  blue: '#2563eb',
  blueBg: 'rgba(37, 99, 235, 0.10)',
  chipBg: 'rgba(0, 0, 0, 0.06)',
  track: 'rgba(0, 0, 0, 0.12)',
  isDark: false,
};

export const MONO = 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace';

export function useSwipePalette(): SwipePalette {
  const theme = useTheme();
  return theme.palette.mode === 'dark' ? DARK : LIGHT;
}

/** Farbe und Hintergrund einer Bewertungsfarbe in dieser Palette. */
export function ratingTone(palette: SwipePalette, farbe: 'rot' | 'gelb' | 'gruen'): { color: string; bg: string; border: string } {
  if (farbe === 'rot') return { color: palette.red, bg: palette.redBg, border: palette.redBorder };
  if (farbe === 'gelb') return { color: palette.yellow, bg: palette.yellowBg, border: palette.yellowBorder };
  return { color: palette.green, bg: palette.greenBg, border: palette.greenBorder };
}
